export const devicesTypeSmartphone = {
  1: "Mobile",
  11: "SmnApp",
};
